import { isEmpty, isNil } from 'ramda';
import { ListContainer, ExecuteParams, PromptFunction } from '../../types';
import { createCustomFunction } from './createFunction';

// 判断一个元素是否被另一个元素包含
const getIsContained = (result: ExecuteParams, contained: ExecuteParams): boolean => {
  if (typeof contained === 'object' && contained.type === 'listContainer') {
    return contained.elements.some(el => getIsContained(result, el))
  } else if (typeof contained === 'object' && contained.type === 'textContainer' && contained.reference) {
    return result === contained.reference
  } else {
    return result === contained
  }
}

/**
 * 上下文相关函数
 * @returns 上下文相关函数对象
 */
const listFunctions: Record<string, PromptFunction> = {
  without: createCustomFunction(
    'without',
    '返回移除指定元素后的数据集合。',
    (_, ...params: ExecuteParams[]): ListContainer<any> | void => {
      const list = [...params];
      const contained = params.length > 1 ? list.pop() : undefined
      const result: ExecuteParams[] = []
      if (contained) {
        params.forEach(param => {
          if (!isNil(param) && !getIsContained(param, contained)) {
            result.push(param)
          }
        })
      }
      if (!result.length) return;
      return {
        type: 'listContainer',
        defaultFormat: 'inherited',
        elements: result,
      }
    }
  ),
}

export default listFunctions;